// extracted by mini-css-extract-plugin
export default {"QuantityEdit":"styles_QuantityEdit__jyNSA","QuantityEditButton":"styles_QuantityEditButton__FxRkl","ButtonOr":"styles_ButtonOr__l6+Og"};